"use client";

import { useState } from "react";

type FormState = { name: string; email: string; subject: string; message: string };
const initialState: FormState = { name: "", email: "", subject: "", message: "" };

export function ContactForm() {
  const [form, setForm] = useState(initialState);
  const [status, setStatus] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  function update(field: keyof FormState, value: string) { setForm((current) => ({ ...current, [field]: value })); }

  async function submit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setLoading(true);
    setStatus(null);
    const response = await fetch("/api/contact", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(form) });
    const payload = await response.json() as { error?: string };
    setLoading(false);
    if (!response.ok) { setStatus(payload.error ?? "Could not send message."); return; }
    setForm(initialState);
    setStatus("Message saved. ABV Labs will follow up from the admin inbox.");
  }

  return <form onSubmit={submit} className="rounded-lg border border-slate-200 bg-white p-6"><div className="grid gap-4"><Field label="Name" value={form.name} onChange={(value) => update("name", value)} /><Field label="Email" type="email" value={form.email} onChange={(value) => update("email", value)} /><Field label="Subject" value={form.subject} onChange={(value) => update("subject", value)} /><label className="grid gap-2 text-sm font-medium text-[#334155]">Message<textarea required rows={5} value={form.message} onChange={(event) => update("message", event.target.value)} className="rounded-md border border-[#CBD5E1] bg-white px-3 py-2 outline-none focus:border-[#F68A00]" /></label><button disabled={loading} className="rounded-md bg-[#F68A00] px-5 py-3 text-sm font-semibold text-white disabled:opacity-60">{loading ? "Sending..." : "Send message"}</button>{status ? <p className="rounded-md border border-slate-200 bg-[#F8FAFC] p-3 text-sm text-[#334155]">{status}</p> : null}</div></form>;
}

function Field({ label, value, onChange, type = "text" }: { label: string; value: string; onChange: (value: string) => void; type?: string }) {
  return <label className="grid gap-2 text-sm font-medium text-[#334155]">{label}<input required type={type} value={value} onChange={(event) => onChange(event.target.value)} className="rounded-md border border-[#CBD5E1] bg-white px-3 py-2 outline-none focus:border-[#F68A00]" /></label>;
}

